export enum QUERY_PARAMS {
    SUPER_USER = 'superUser',
    ORG_TYPE = 'orgType',
    NEW_DEAL = 'newDeal',
    DEAL_ID = 'dealId',
    QUERY = 'query',
    DEBUG = 'debug',
    ID = 'id',
    ORG_ID = 'orgId',
    BACK = 'back',
    AUTH_TOKEN = 'authToken',
    TAB = 'tab',
    CODE = 'code',
    STATE = 'state',
}

export enum ORGANIZATION_SETTINGS_TABS {
    DETAILS = 'details',
    BILLING = 'billing',
    TEAM = 'team',
    FEATURES = 'features',
    DANGER_ZONE = 'danger-zone',
}

export enum INTEGRATION_TABS {
    CUSTOMER_FORM = 'customer-form',
    ACCOUNTING = 'accounting',
}

export enum LOCAL_STORAGE_KEYS {
    MAGIC_LINK_EMAIL = 'magic_link_email',
}

export enum PATHS {
    SUPER_ADMIN = '/super-admin',
    CARD_EDIT = '/card/edit',
    PIPELINE_EDIT = '/pipeline/edit',
    DEALS = '/deals',
    MAP = '/map',
    USER_PREFERENCES = '/user-preferences',
    ORGANIZATIONSETTINGS = '/organization-settings',
    INTEGRATIONS = '/integrations',
    SEARCH = '/search',
    CUSTOMERS = '/customers',
    CUSTOMERS_EDIT = '/customers/edit',
    ARTICLES = '/articles',
    ARTICLES_EDIT = '/articles/edit',
    EQUIPMENT = '/equipment',
    EQUIPMENT_EDIT = '/equipment/edit',
    TIMESHEETS = '/timesheets',
    SUPPORT = '/support',
    INVITE = '/invite',
    SHARED = '/shared',
    OFFERS = '/offers',
    INVOICES = '/invoices',
    NEW = '/new',
    DEAL_TIMELINE = "/dealTimeline",
}

export enum COLLECTIONS {
    CONFIG = 'config',
    USERS = 'users',
    ORGANIZATIONS = 'organizations',
    DEALS = 'deals',
    LOCKS = 'locks',
    CUSTOMERS = 'customers',
    ARTICLES = 'articles',
    USER_INVITATIONS = 'userInvitations',
    SHARE_TOKENS = 'shareTokens',
    OFFERS = "offers",
    INVOICES = "invoices",
    TIME_RECORDS = "timeRecords",
    ACTIVE_TIME_RECORDS = "activeTimeRecords",
    AUTH_TOKENS = 'authTokens',
    SECRETS = 'secrets',
    EQUIPMENT = 'equipment',
    COUNTERS = 'counters',
}

export enum STORAGE_PATHS {
    ORGANIZATIONS = 'organizations',
    DEALS = 'deals',
    PUBLIC = 'public',
    ATTACHEMENTS = 'attachments',
}

export enum CONFIG_KEYS {
    PRIVATE = 'private',
    PUBLIC = 'public',
}

export const SUPPORT_EMAIL = 'info@arbtask.com';

export const DND_ACTIVATION_DISTANCE_CONSTRAINT = { distance: 5 };
export const DND_ACTIVATION_DELAY_CONSTRAINT = { delay: 400, tolerance: 10 };

export const MAP_RENDER_API_KEY = 'AIzaSyCl-JuHmIJiWEHK70vKJd8ZH7Lc2ui0TVc';

export enum LANGUAGE {
    EN = 'en',
    SV = 'sv',
    CS = 'cs',
}

export type OrgCurrency = 'SEK' | 'USD' | 'CZK' | 'DKK' | 'EUR';

export const LANGUAGE_DEFAULT_CURRENCY: Record<LANGUAGE, OrgCurrency> = {
    [LANGUAGE.SV]: 'SEK',
    [LANGUAGE.CS]: 'CZK',
    [LANGUAGE.EN]: 'USD',
};

export const ATTACHEMENT_MAX_FILE_SIZE_MB = 8;

export const MARKETING_WEBSITE = 'https://arbtask.com';

// Absolute so the native app opens it in the browser instead of inside its WebView
export const PRIVACY_POLICY_URL = 'https://app.arbtask.com/privacy-policy.html';

export const DEFAULT_STEP_COLOR = '#E7D9C9';

export const DISCOUNT_LINE_ITEM_ID = 'offer-discount';

export const INVOICE_COUNTER_DOC_ID = 'invoices';
export const FIRST_INVOICE_NUMBER = 1000;

// Size constants for avatars and logos
export const AVATAR_SIZE = {
    MD: 150,
    SM: 50,
    XS: 30,
    XXS: 20,
};

export const ARB_TASK_MAP_ID = 'a95cac7a8e8d2e95a888a5ee';

export const MAIL_APP_TAG = 'arbtask';

export enum EMAIL_TEMPLATES {
    LOGIN_EMAIL = 'loginEmail',
    NEW_USER_EMAIL = 'welcome email campaign',
    ONBOARDING_NO_DEAL = 'email2_onboarding_nudge',
    FEATURE_HIGHLIGHT = 'email3_feature_highlight_active_only',
    FEEDBACK = 'email4_feedback_upgrade_nudge',
    UPGRADE_NUDGE = 'email5_upgrade_trigger'
}


export type PlanId = 'free' | 'arbtask_base' | 'arbtask_business' | 'arbtask_enterprise';
export type PlanInterval = 'yearly' | 'monthly';
export type Plan = {
    id: PlanId;
    name: string;
    prices: Record<PlanInterval, PlanPrice>;
};

export type PlanPrice = {
    cost: string;
    currency: 'sek'
}

export const PAID_PLANS: Plan[] = [
    {
        id: 'arbtask_base',
        name: 'ArbTask Starter',
        prices: {
            monthly: {
                cost: '49900',
                currency: 'sek',
            },
            yearly: {
                cost: '499900',
                currency: 'sek',
            },
        },
    },
    {
        id: 'arbtask_business',
        name: 'ArbTask Growth',
        prices: {
            monthly: {
                cost: '99900',
                currency: 'sek',
            },
            yearly: {
                cost: '999900',
                currency: 'sek',
            },
        },
    },
    {
        id: 'arbtask_enterprise',
        name: 'ArbTask Enterprise',
        prices: {
            monthly: {
                cost: '199900',
                currency: 'sek',
            },
            yearly: {
                cost: '1999000',
                currency: 'sek',
            },
        },
    },
];

export const PLAN_DEAL_LIMITS: Record<PlanId, number> = {
    free: 5,
    arbtask_base: 30,
    arbtask_business: 100,
    arbtask_enterprise: -1,
};

export const PLAN_NAMES: Record<PlanId, string> = {
    free: 'Free',
    arbtask_base: PAID_PLANS.find(p => p.id === 'arbtask_base')!.name,
    arbtask_business: PAID_PLANS.find(p => p.id === 'arbtask_business')!.name,
    arbtask_enterprise: PAID_PLANS.find(p => p.id === 'arbtask_enterprise')!.name,
};

